import { faAngleDown, faBed, faCalendarWeek, faCircle, faHouse, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
    Button,
    Card,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
} from "react-bootstrap";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import { Card1, Card2, Card3, Filters } from "../../../../../assets/images";
import PaginationComponent from "../../../CommanComponents/Pagination";

const PatientListLab = () => {
    const breadcrumData = ['Dashboard', 'Cardiology'];
    const breadcrumItem = ['Patient List'];
    return (
        <div className="patient_list_lab">
            <WithoutImageHeader
                header={Constants.PATIENT_LIST_LAB}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                icon={'notification'}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="patient_list_area">
                            <div className="search_filter_main">
                                <div className="left_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                            />
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="right_area">
                                    <div className="inner_area">
                                        <div className="inner_left">
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Select>
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={15}>15</option>
                                                        <option value={20}>20</option>
                                                        <option value={25}>25</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Form>
                                        </div>
                                        <div className="inner_right">
                                            <div className="filter_button">
                                                <Button className="btn-primary">
                                                    <Image
                                                        src={Filters}
                                                        alt="..."
                                                        className="image_area"
                                                    />
                                                    Filters
                                                </Button>
                                                <FontAwesomeIcon
                                                    icon={faCircle}
                                                    className="filter_icon"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text">
                                <p>Total Patients : 150</p>
                            </div>
                            <div className="listing_main_area">
                                <div className="list_inner_area">
                                    <div className="left_area">
                                        <div className="img_con_area">
                                            <div className="left">
                                                <div className="img_area">
                                                    <Image src={Card1} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <h5>Robert William </h5>
                                                <div className="top_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faVenus} className="icon_area" />Female</li>
                                                        <li><div className="label">Cardiology</div></li>
                                                    </ul>
                                                </div>
                                                <div className="mid_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faBed} className="icon_area" />Bed #05</li>
                                                        <li><FontAwesomeIcon icon={faHouse} className="icon_area" />Room #05</li>
                                                    </ul>
                                                </div>
                                                <div className="bottom_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faCalendarWeek} className="icon_area" />5 July, 2023</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="last_btn_area">
                                            <div className="number_txt">UHID : 54674857</div>
                                            <div className="btn_main">
                                                <a href="javascript:;" className="btn_text treatment">Under Treatment</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="list_inner_area">
                                    <div className="left_area">
                                        <div className="img_con_area">
                                            <div className="left">
                                                <div className="img_area">
                                                    <Image src={Card2} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <h5>Robert William </h5>
                                                <div className="top_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faVenus} className="icon_area" />Female</li>
                                                        <li><div className="label">Cardiology</div></li>
                                                    </ul>
                                                </div>
                                                <div className="mid_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faBed} className="icon_area" />Bed #05</li>
                                                        <li><FontAwesomeIcon icon={faHouse} className="icon_area" />Room #05</li>
                                                    </ul>
                                                </div>
                                                <div className="bottom_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faCalendarWeek} className="icon_area" />5 July, 2023</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="last_btn_area">
                                            <div className="number_txt">UHID : 54674857</div>
                                            <div className="btn_main">
                                                <a href="javascript:;" className="btn_text critical">Critical</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="list_inner_area">
                                    <div className="left_area">
                                        <div className="img_con_area">
                                            <div className="left">
                                                <div className="img_area">
                                                    <Image src={Card3} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <h5>Robert William </h5>
                                                <div className="top_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faVenus} className="icon_area" />Female</li>
                                                        <li><div className="label">Cardiology</div></li>
                                                    </ul>
                                                </div>
                                                <div className="mid_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faBed} className="icon_area" />Bed #05</li>
                                                        <li><FontAwesomeIcon icon={faHouse} className="icon_area" />Room #05</li>
                                                    </ul>
                                                </div>
                                                <div className="bottom_list">
                                                    <ul>
                                                        <li><FontAwesomeIcon icon={faCalendarWeek} className="icon_area" />5 July, 2023</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="last_btn_area">
                                            <div className="number_txt">UHID : 54674857</div>
                                            <div className="btn_main">
                                                <a href="javascript:;" className="btn_text success">Admitted</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PaginationComponent />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PatientListLab;
